'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var SESSION_START_EVENT = 'session:start:event';
var BETS_PLACED_EVENT = 'bets:placed:event';
var BET_WINS_EVENT = 'bet:wins:event';
var USER_LOGIN_TIME_EVENT = 'user:login:time:event';
var RESET_GAME_SESSION_COMMAND = 'reset:game:session:command';

exports.BETS_PLACED_EVENT = BETS_PLACED_EVENT;
exports.BET_WINS_EVENT = BET_WINS_EVENT;
exports.RESET_GAME_SESSION_COMMAND = RESET_GAME_SESSION_COMMAND;
exports.SESSION_START_EVENT = SESSION_START_EVENT;
exports.USER_LOGIN_TIME_EVENT = USER_LOGIN_TIME_EVENT;
